<div class="row align-top gutters">
  <div class="col-md-6">
    <div class="subsection-header indigo">Economic Impact</div>
    <div class="mat-elevation-z8">
      <table mat-table class="stripped-table" #economicTable
        [dataSource]="economicDataSource" matSort>

        <!-- Field Column -->
        <ng-container matColumnDef="field">
          <th mat-header-cell *matHeaderCellDef> Field </th>
          <td mat-cell class="name-column" *matCellDef="let row"> {{row.field}} </td>
        </ng-container>

        <!-- Formula Column -->
        <ng-container matColumnDef="formula">
          <th mat-header-cell *matHeaderCellDef> Formula </th>
          <td mat-cell class="formula-column" *matCellDef="let row"> {{row.formula}} </td>
        </ng-container>

        <!-- Value Column -->
        <ng-container matColumnDef="value">
          <th mat-header-cell *matHeaderCellDef> Value </th>
          <td mat-cell *matCellDef="let row"> {{row.value}} </td>
        </ng-container>

        <tr mat-row *matRowDef="let row; columns: economicColumns;"></tr>
      </table>
    </div>
  </div>
  <div class="col-md-6">
    <div class="subsection-header indigo">Unit Set-Asides</div>
    <div class="row">
      <div class="col-md-12">
        @if (permissions.projectDetailPermissions._edit) {
          <button mat-raised-button class="edit-button"
            (click)="saveSetAsides()" [ngClass]="enableButtons ? '' : 'disabled'">
            @if (!isEditMode) {
              <span>Edit</span>
            }
            @if (isEditMode) {
              <span>Save</span>
            }
          </button>
        }

        @if (permissions.projectDetailPermissions._edit && isEditMode) {
          <button mat-raised-button class="add-button"
            (click)="addUnitSetAside()" [ngClass]="enableButtons ? '' : 'disabled'">
            Add
          </button>
        }

        @if (permissions.projectDetailPermissions._edit && isEditMode) {
          <button mat-raised-button class="add-button"
            (click)="addUnitSetAsideType()" [ngClass]="enableButtons ? '' : 'disabled'">
            Add Set-Aside Type
          </button>
        }
      </div>
    </div>
    <div class="set-asides-question">
      <b>Are there any Unit Set-Asides for this deal? </b>
      @if (!permissions.projectDetailPermissions._edit || !isEditMode) {
        <span>{{hasSetAsidesString}}</span>
      }
      @if (permissions.projectDetailPermissions._edit && isEditMode) {
        <mat-radio-group [(ngModel)]="hasSetAsides" aria-label="Select yes or no for Unit Set-Asides">
          <mat-radio-button [value]="true">Yes</mat-radio-button>
          <mat-radio-button [value]="false">No</mat-radio-button>
        </mat-radio-group>
      }
    </div>

    @if (project.projectSetAsides.length > 0 || this.setAsides.length > 0) {
      <div class="mat-elevation-z8">
        <table mat-table class="stripped-table" #setAsideTable
          #dataSort="matSort" [dataSource]="setAsideDataSource" matSort>
          <!-- Type Column -->
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
            <td mat-cell *matCellDef="let row">
              @if (!permissions.projectDetailPermissions._edit || !isEditMode) {
                <span>
                  {{row.type}}
                </span>
              }
              @if (permissions.projectDetailPermissions._edit && isEditMode) {
                <mat-form-field>
                  <mat-label>Select Set-Aside Type</mat-label>
                  <mat-select [(value)]="row.typeidnew">
                    @for (type of setAsideTypes; track type) {
                      <mat-option [value]="type.id" (click)="buttonsEnabled()">
                        {{type.name}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              <div class="row">
                <div class="col-md-12">
                  @if (row.typeidnew === '') {
                    <small class="error-text">
                      Select Set-Aside Type
                    </small>
                  }
                </div>
              </div>
            </td>
          </ng-container>
          <!-- Units Number Column -->
          <ng-container matColumnDef="unitsNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> # of Units </th>
            <td mat-cell *matCellDef="let row; let i = index">
              @if (!permissions.projectDetailPermissions._edit || !isEditMode) {
                <span>
                  {{row.unitsNumber}}
                </span>
              }
              <form>
                @if (permissions.projectDetailPermissions._edit && isEditMode) {
                  <mat-form-field class="example-full-width">
                    <input type="number" matInput
                      placeholder="Enter units"
                      [value]="row.unitsNumberNew"
                      (input)="updateUnits($event, i)"
                      [required]>
                  </mat-form-field>
                }
                <div class="row">
                  <div class="col-md-12">
                    @if (!row.unitsNumberNew) {
                      <small class="error-text">
                        Enter number of units
                      </small>
                    }
                  </div>
                </div>
              </form>
            </td>
          </ng-container>
          <!-- Hard/Best Effort Column -->
          <ng-container matColumnDef="hardBestEffort">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Hard/Best Effort </th>
            <td mat-cell *matCellDef="let row; let i = index;">
              @if (!permissions.projectDetailPermissions._edit || !isEditMode) {
                <span>
                  {{row.hardBestEffort}}
                </span>
              }
              @if (permissions.projectDetailPermissions._edit && isEditMode) {
                <mat-form-field>
                  <mat-label>Select Hard/Best Effort</mat-label>
                  <mat-select [(value)]="row.hardBestEffortNew">
                    <mat-option [value]="true" (click)="buttonsEnabled()">Hard</mat-option>
                    <mat-option [value]="false" (click)="buttonsEnabled()">Best Effort</mat-option>
                    <mat-option [value]="'Unknown'" (click)="buttonsEnabled()">Unknown</mat-option>
                  </mat-select>
                </mat-form-field>
              }
              @if (permissions.projectDetailPermissions._edit && isEditMode) {
                <button
                  mat-icon-button color="warn" aria-label="Delete Set-Aside" (click)="deleteSetAside(row, i)">
                  <mat-icon>clear</mat-icon>
                </button>
              }
              <div class="row">
                <div class="col-md-12">
                  @if (row.hardBestEffortNew === '') {
                    <small class="error-text">
                      Select Hard/Best Effort
                    </small>
                  }
                </div>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="setAsideColumns"></tr>
          <tr mat-row *matRowDef="let row; columns:setAsideColumns;"></tr>
        </table>
      </div>
    }
  </div>
</div>
